<template>
    <v-card
        class="ma-6"
    >
        <v-card-title>
            <v-icon color="primary" class="mr-6">timeline</v-icon>
            Dashboard
            <div class="flex-grow-1"></div>
            <div class="flex-grow-1"></div>
            <v-text-field  color="green"
                v-model="search"
                append-icon="search"
                label="Search by Group or CatCode"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>

        <v-data-table
            class="row-pointer"
            dense
            :headers="headers"
            :options.sync="options"

            @click:row="rowClicked"
            
            :items="items"
            :server-items-length="totalItems"

            :footer-props="{
                itemsPerPageOptions: [10,20,100,500,-1]
            }"

            :search="search"

            loading-text="Loading...please wait"
            :loading="loading"
        >
        
            <template v-slot:item.latestScan="{ item }">
                {{ item.latestScan | toDateOnly('') }}
            </template>



            <template v-slot:item.pricePercentChange30Day="{ item }" :color="getColor(item.pricePercentChange30Day)">
                <v-card v-if="(item.pricePercentChange30Day) >= 50 || (item.pricePercentChange30Day) <= -50" :color="getColor(item.pricePercentChange30Day)">
                    {{ item.pricePercentChange30Day }}
                </v-card>
                <div v-else>
                    {{ item.pricePercentChange30Day }}
                </div>
            </template>

            <template v-slot:item.qtyChange30Day="{ item }" :color="getColor(item.qtyChange30Day)">
                <v-card v-if="(item.qtyChange30Day) >= 50 || (item.qtyChange30Day) <= -50" :color="getColor(item.qtyChange30Day)">
                    {{ item.qtyChange30Day }}
                </v-card>
                <div v-else>
                    {{ item.qtyChange30Day }}
                </div>
            </template>

            <template v-slot:item.pricePercentChange90Day="{ item }" :color="getColor(item.pricePercentChange90Day)">
                <v-card v-if="(item.pricePercentChange90Day) >= 50 || (item.pricePercentChange90Day) <= -50" :color="getColor(item.pricePercentChange90Day)">
                    {{ item.pricePercentChange90Day }}
                </v-card>
                <div v-else>
                    {{ item.pricePercentChange90Day }}
                </div>
            </template>

            <template v-slot:item.qtyChange90Day="{ item }" :color="getColor(item.qtyChange90Day)">
                <v-card v-if="(item.qtyChange90Day) >= 50 || (item.qtyChange90Day) <= -50" :color="getColor(item.qtyChange90Day)">
                    {{ item.qtyChange90Day }}
                </v-card>
                <div v-else>
                    {{ item.qtyChange90Day }}
                </div>
            </template>

            <template v-slot:item.pricePercentChange180Day="{ item }" :color="getColor(item.pricePercentChange180Day)">
                <v-card v-if="(item.pricePercentChange180Day) >= 50 || (item.pricePercentChange180Day) <= -50" :color="getColor(item.pricePercentChange180Day)">
                    {{ item.pricePercentChange180Day }}
                </v-card>
                <div v-else>
                    {{ item.pricePercentChange180Day }}
                </div>
            </template>

            <template v-slot:item.qtyChange180Day="{ item }" :color="getColor(item.qtyChange180Day)">
                <v-card v-if="(item.qtyChange180Day) >= 50 || (item.qtyChange180Day) <= -50" :color="getColor(item.qtyChange180Day)">
                    {{ item.qtyChange180Day }}
                </v-card>
                <div v-else>
                    {{ item.qtyChange180Day }}
                </div>
            </template>

        </v-data-table>
    </v-card>
</template>


<style lang="css" scoped>
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
</style>

<script>
  import {SystemStatsService} from '../../services/api/systemStats';
  const apiSystemStats = new SystemStatsService();

  import _ from "lodash";

    export default {
        data () {
        return {
            totalItems: 0,
            items: [],
            loading: true,
            options: {
                itemsPerPage: 20,
            },

            search: '',

            headers: [
                { text: 'CAT Code', value: 'catCodeString', width: 60 },
                { text: 'Description', value: 'catCodeDesc' },
                { text: 'Group', value: 'group', width: 40 },
                //{ text: 'Latest Scan', value: 'latestScan', width: 80 },
                { text: '', value: '', width: 50, sortable: false },

                { text: '30-Day Price', value: 'price30Day', width: 20, align: 'right' },
                { text: '30-Day Price Change %', value: 'pricePercentChange30Day', width: 20, align: 'right' },
                { text: '30-Day Qty Avg', value: 'qty30Day', width: 20, align: 'right' },
                { text: '30-Day Qty Avg Change', value: 'qtyChange30Day', width: 20, align: 'right' },
                { text: '', value: '', width: 30, sortable: false },

                { text: '90-Day Avg Price', value: 'price90Day', width: 20, align: 'right' },
                { text: '90-Day Avg Price Change', value: 'pricePercentChange90Day', width: 20, align: 'right' },
                { text: '90-Day Qty Avg', value: 'qty90Day', width: 20, align: 'right' },
                { text: '90-Day Qty Avg Change', value: 'qtyChange90Day', width: 20, align: 'right' },
                { text: '', value: '', width: 30, sortable: false },
                
                { text: '180-Day Avg Price', value: 'price180Day', width: 20, align: 'right' },
                { text: '180-Day Avg Price Change', value: 'pricePercentChange180Day', width: 20, align: 'right' },
                { text: '180-Day Qty Avg', value: 'qty180Day', width: 20, align: 'right' },
                { text: '180-Day Qty Avg Change', value: 'qtyChange180Day', width: 20, align: 'right' },
            ],
        }
      },

       watch: {
            options: {
                handler () {
                    this.loadItems()
                    },
                deep: true,
            },
            // Watch for changes to the search text.
            search: function () {
                this.debouncedloadItems();
            }
        },

        created: function () {
            this.debouncedloadItems = _.debounce(this.loadItems, 500);
        },

        methods: {
            loadItems () {
                this.loading = true
                return new Promise((resolve, reject) => {
                    this.getDashboard();
                })
            },
            getColor(percentChange) {
                if (percentChange >= 50) return 'green'
                else if (percentChange <= -50) return 'orange'
                else return '';
            },

            getDashboard () {
                this.loading = true;

                // Clear our list so the loading text will be shown.
                this.items = [];

                // Set up our search, sort, and paging parameters
                const search = {
                    searchText: this.search,
                    
                    // If there's a sortBy field set, then use it; otherwise use a reasonable default.
                    sortOrderField: this.options.sortBy.length == 1 ? this.options.sortBy[0] : "CatCodeString",
                    // If there's no sortDesc defined, sort by desc.  Otherwise sort by the value.
                    sortDirection: this.options.sortDesc.length == 0 ? "desc" : (this.options.sortDesc[0] ? "desc" : "asc"),
                    itemsPerPage: this.options.itemsPerPage,
                    itemsToSkip: this.options.itemsPerPage * (this.options.page - 1),
                    
                }

                // Get the list of items from the API.
                apiSystemStats.getDashboard(search).then((data) => {
                    this.items = data.items
                    this.totalItems = data.totalItemCount;
                });

                this.loading = false;
            },

            // When a row is clicked, go to the detail page.
            rowClicked(item) {
                //this.$router.push({ name: "CatCodeEdit", params: { id : item.id } });
                this.$router.push({ name: "CatCode", params: { catCodeString : item.catCodeString } });
            },
    },
}
</script>